import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { ConfigsService } from './configs.service';

@NgModule({
  imports: [
    HttpClientModule,
  ],
})
export class ConfigsModule {
  constructor() {}

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ConfigsModule,
      providers: [
        ConfigsService,
      ],
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configs/configs.module.ts